import * as React from 'react';

const incrementReducer: React.Reducer<number, void> = (c) => c + 1;

/** Returns a function that forces the component to re-render when called. */
export const useForceUpdate = () => React.useReducer(incrementReducer, 0)[1];
